import React, { useEffect, useState } from "react";
import {
  Stack,
  Button,
  FormControlLabel,
  Modal,
  Fade,
  Box,
  Radio,
  Checkbox,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Navigate, useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  startOverAPICall,
  segmentDetailsAPICall,
  segmentDetailsPostAPICall,
  stageDetailsAPICall,
  CommonDropDownAPICall,
} from "../shared/APICalls";
import routesData from "../shared/routes.json";
import TradingStyles from "../pages/Styles/TradingPreference.module.scss";
import TickCircle from "../Components/assets/Images/Checkbox base_new.svg";
import EmptyCircle from "../Components/assets/Images/CheckboxEmptyNew.svg";
import BackDrop from "../Components/BackDrop";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/tradingicongrey.svg";
import backicon from "../Components/assets/Images/back.svg";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import { useDispatch } from "react-redux";
import TagManager from "react-gtm-module";
import ProgressComp from "../Components/ProgressComp/ProgressComp";
import TermsandConditionsPage from "./TermsandConditionsPage";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Checkboxempty from "../Components/assets/Images/Checkboxempty.svg";
import Checkboxdone from "../Components/assets/Images/Checkbox base_new.svg";
import SideBar from "../Components/SideBar/SideBar";
import equityimage from "../Components/assets/Images/equityimage.svg";
import fnoimage from "../Components/assets/Images/fnoimage.svg";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ProgressBar from "../Components/ProgressBar/ProgressBar";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MenuIcon from "@mui/icons-material/Menu";

const TradingPreferenceSchema = Yup.object().shape({
  Equity: Yup.boolean().oneOf([true], "Equity is required"),
});

export default function TradingPreference() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const [segmentData, setSegmentData] = useState<any>([]);
  const [prefilloading, setprefilloading] = useState(true);
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [expandTerms, setExpandTerms] = useState(false);
  const [termsChecked, setTermsChecked] = useState(true);
  const [tradingPreferenceData, setTradingPreferneceData] = useState<any>();
  const [expandMenu, setExpandMenu] = useState<any>(false);
  const [nominationInformation, setNominationInformation] = useState("nominee_status");

  const [prefillData, setprefillData] = useState<any>({
    equity: true,
    futures_and_options: false,
    currency: false,
    commodity: true,
    mutual_funds: true,
  });
  const [termsandconditions, settermsandconditions] = useState({
    is_t_and_c: true,
    settlement_preference: "",
    terms_and_conditions: {
      dp_automatic_credit: "",
      accept_all_pledge_instructions: "",
      account_statement_requirement: "",
      electronic_transaction_holding_statement: "",
      share_email_with_rta: "",
      receive_annual_report: "",
      is_bsda_required: "",
      receive_dividend_to_bank_account: "",
      mobile_sms_alert_facility: "",
      dis_booklet: "",
      easi_facility: "",
      elect_trans_of_demat_holding_email: "",
    },
  });

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    let dd_type = "segments";
    CommonDropDownAPICall(dd_type)
      .then((response: any) => {
        const responseData = response.data.data.segments;

        setSegmentData(
          responseData.filter(
            (a: any) => a.segment_link === "futures_and_options",
          ),
        );
      })
      .catch((error: any) => {});

    let obj: any = {
      stage: "segment",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        dispatch(setCompletedStages(responseData.data.completed_stages));
        dispatch(setCurrentStage(responseData.data.current_stage));
        setprefilloading(false);
        if (responseData?.data?.data?.length) {
          setprefillData((prev) => {
            return {
              ...prev,
              equity: responseData?.data?.data?.filter(
                (a: any) => a.label === "equity",
              )[0]?.opted,
              futures_and_options: responseData?.data?.data?.filter(
                (a: any) => a.label === "futures_and_options",
              )[0]?.opted,
              currency: responseData?.data?.data?.filter(
                (a: any) => a.label === "currency",
              )[0]?.opted,
              commodity: responseData?.data?.data?.filter(
                (a: any) => a.label === "commodity",
              )[0]?.opted,
              mutual_funds: responseData?.data?.data?.filter(
                (a: any) => a.label === "mutual_funds",
              )[0]?.opted,
            };
          });
        }
        if (response.data.data.ErrorMessage) {
          setRejectMessage(response.data.data.ErrorMessage);
        }
      })
      .catch((error: any) => {
        setprefilloading(false);
        // console.log("error", error);
      });
  }, []);

  // console.log("termsandconditions", termsandconditions);

  function segmentDetailsPost(data: any) {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitTradingPreference",
      },
    });
    // console.log("data", data);
    setloading(true);

    let obj = {
      segment_list: {
        equity: {
          label: "equity",
          opted: true,
        },
        mutual_funds: {
          label: "mutual_funds",
          opted: true,
        },
        futures_and_options: {
          label: data[0].segment_link,
          opted: data[0].isOpted,
        },
        commodity: {
          label: "commodity",
          opted: false,
        },
        currency: {
          label: "currency",
          opted: false,
        },
      },
      is_t_and_c: termsandconditions.is_t_and_c,
      settlement_preference: termsandconditions.settlement_preference,
      terms_and_conditions: {
        ...termsandconditions?.terms_and_conditions,
        nominee_statement: nominationInformation,
      },
    };

    // if (data[0].isOpted) {
    //   setshowModal(true);
    //   setTradingPreferneceData(obj);
    // } else {
    segmentDetailsPostAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", responseData);
        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
    // }
  }

  const handleRiskDisclosure = () => {
    segmentDetailsPostAPICall(tradingPreferenceData)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", responseData);
        setloading(false);

        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
        setshowModal(false);
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                // console.log("responseData", response);
                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
              });
          },
        },
      ],
    });
  };

  const InitialValues = {
    equity: true,
    futures_and_options: prefillData.futures_and_options,
    // currency: !prefillData.currency,
    // commodity: prefillData.commodity,
    mutual_funds: prefillData.mutual_funds,
  };

  //console.log(selectedCheckboxes);

  const handleCheckBoxClick = (name: any, callback: any, values: any) => {
    callback(name, !values[name]);
  };

  return (
    <>
      <ErrorSnackBar message={rejectMessage} />
      {backdrop && <StartOverBackDrop />}
      <div className={TradingStyles.layout}>
        <div className={TradingStyles.sidebar}>
          <SideBar />
        </div>
        <div className={TradingStyles.pageContent}>
          <div className={TradingStyles.mainWrapper}>
            <div className={TradingStyles.wrapper}>
              {/* <div
                className={TradingStyles.backTop}
                onClick={() => {
                  navigate("/linkusingifsc");
                }}
              >
                <img src={backicon} />{" "}
                <span className={TradingStyles.backText}>Back</span>
              </div> */}

              {!prefilloading ? (
                <Formik
                  initialValues={InitialValues}
                  validationSchema={TradingPreferenceSchema}
                  onSubmit={(values) => {
                    const selectedSegments = segmentData
                      .filter((segment: any) => values[segment.segment_link])
                      .map((segment: any) => ({
                        segmentName: segment.value,

                        segmentLink: segment.segment_link,
                      }));

                    const updatedSegmentData = segmentData.map((a: any) => {
                      const isOpted = selectedSegments.some(
                        (b: any) => b.segmentLink === a.segment_link,
                      );
                      return { ...a, isOpted };
                    });
                    segmentDetailsPost(updatedSegmentData);
                  }}
                >
                  {({
                    errors,
                    touched,
                    handleSubmit,
                    setFieldValue,
                    values,
                  }) => {
                    // console.log("values", values);
                    return (
                      <Form
                        onKeyDown={(event) => {
                          event.code === "Enter" ||
                            (event.code === "NumpadEnter" && handleSubmit());
                        }}
                        style={{ width: "100%" }}
                      >
                        <div className={TradingStyles.contentwrapper}>
                          <div className={TradingStyles.headerSection}>
                            <p className={TradingStyles.signup}>
                              <div
                                className={TradingStyles.mobileBack}
                                onClick={() => {
                                  navigate("/bank");
                                }}
                              >
                                <ArrowBackIosIcon />
                              </div>
                              {/* Choose Your  */}
                              Trading Preference{" "}
                              <div
                                className={TradingStyles.mobileMenu}
                                onClick={() => {
                                  setExpandMenu(!expandMenu);
                                }}
                              >
                                {expandMenu ? <CloseIcon /> : <MenuIcon />}
                              </div>
                            </p>
                            <ProgressBar />
                            <div
                              className={TradingStyles.mobileexpandedMenu}
                              style={{
                                height: expandMenu ? "100%" : "0%",
                              }}
                            >
                              <div className={TradingStyles.mobilemenuContent}>
                                <SideBar />
                              </div>
                            </div>
                            <p className={TradingStyles.subText}>
                              Personalize your trading journey based on your
                              style
                            </p>
                          </div>
                          <div className={TradingStyles.feildWrapper}>
                            <div
                              className={TradingStyles.checkBoxFeild}
                              // style={{
                              //   background: "#F9FAFB",
                              //   border: "1px solid #E5E7EB",
                              // }}
                            >
                              <FormControlLabel
                                sx={{ marginRight: "10px", width: "100%" }}
                                control={
                                  <Radio
                                    icon={
                                      <img src={TickCircle} width={"24px"} />
                                    }
                                    checkedIcon={
                                      <img src={TickCircle} width={"24px"} />
                                    }
                                    name={"equity"}
                                    className={TradingStyles.radiobutton}
                                    checked
                                  />
                                }
                                label={
                                  <div className={TradingStyles.textimgWrap}>
                                    <div className={TradingStyles.imgWrap}>
                                      <img src={equityimage} alt="" />
                                    </div>
                                    <div className={TradingStyles.text}>
                                      <div> Equity & Mutual Funds</div>
                                      <div className={TradingStyles.des}>
                                        Trade Shares. Invest in Mutual Funds.
                                      </div>
                                    </div>
                                  </div>
                                }
                              />
                              <div className={TradingStyles.default}>
                                <span className={TradingStyles.defaultLabel}>
                                  Default
                                </span>
                              </div>
                            </div>

                            {segmentData.map((segment: any, index: any) => (
                              <div
                                className={TradingStyles.checkBoxFeild}
                                key={segment.segment_link}
                              >
                                <FormControlLabel
                                  sx={{ marginRight: "10px", width: "100%" }}
                                  control={
                                    <Radio
                                      disableFocusRipple
                                      disableRipple
                                      disableTouchRipple
                                      icon={
                                        values[segment.segment_link] ===
                                        true ? (
                                          <img
                                            src={TickCircle}
                                            width={"44px"}
                                          />
                                        ) : (
                                          <img
                                            src={EmptyCircle}
                                            width={"44px"}
                                          />
                                        )
                                      }
                                      checkedIcon={
                                        values[segment.segment_link] ===
                                        "equity" ? (
                                          <img
                                            src={EmptyCircle}
                                            width={"44px"}
                                          />
                                        ) : (
                                          <img
                                            src={TickCircle}
                                            width={"44px"}
                                          />
                                        )
                                      }
                                      name={segment.segment_link}
                                      onClick={(e) => {
                                        if (segment.segment_link !== "equity") {
                                          e.stopPropagation();
                                          handleCheckBoxClick(
                                            segment.segment_link,
                                            setFieldValue,
                                            values,
                                          );
                                        }
                                      }}
                                      className={TradingStyles.radiobutton}
                                      value={values[segment.segment_link]}
                                      checked={values[segment.segment_link]}
                                    />
                                  }
                                  label={
                                    <div className={TradingStyles.textimgWrap}>
                                      <div className={TradingStyles.imgWrap}>
                                        <img src={fnoimage} alt="" />
                                      </div>
                                      <div className={TradingStyles.text}>
                                        <div>
                                          {" "}
                                          {segment.segmentName === "F&O"
                                            ? "F&O"
                                            : segment.value}
                                        </div>
                                        <div className={TradingStyles.des}>
                                          Trade in Futures and Options
                                        </div>
                                      </div>
                                    </div>
                                  }
                                />
                              </div>
                            ))}
                            {/* </FormGroup> */}
                          </div>

                          <div>
                            <TermsandConditionsPage
                              expandTerms={expandTerms}
                              settermsandconditions={settermsandconditions}
                              setTermsChecked={setTermsChecked}
                              setNominationInformation={setNominationInformation}
                              nominationInformation={nominationInformation}
                            />
                          </div>

                          {/* <div className={TradingStyles.nominationInformation}>
                            <div
                              className={
                                TradingStyles.nominationInformationText
                              }
                            >
                              I/We hereby choose to receive the following
                              nomination information in the periodic statement
                              of holdings/accounts:
                            </div>
                            <Stack direction={"row"} gap={"24px"}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      nominationInformation === "nominee_name"
                                    }
                                    icon={<img src={EmptyCircle} alt="" />}
                                    checkedIcon={
                                      <img src={TickCircle} alt="" />
                                    }
                                    onChange={() => {
                                      setNominationInformation((current) =>
                                        current === "nominee_name"
                                          ? "nominee_name"
                                          : "nominee_name",
                                      );
                                    }}
                                  />
                                }
                                label={
                                  <div className={TradingStyles.checkboxlabel}>
                                    Nominee Name(s)
                                  </div>
                                }
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      nominationInformation ===
                                      "nominee_status"
                                    }
                                    icon={<img src={EmptyCircle} alt="" />}
                                    checkedIcon={
                                      <img src={TickCircle} alt="" />
                                    }
                                    onChange={() => {
                                      setNominationInformation((current) =>
                                        current === "nominee_status"
                                          ? "nominee_status"
                                          : "nominee_status",
                                      );
                                    }}
                                  />
                                }
                                label={
                                  <div className={TradingStyles.checkboxlabel}>
                                    Nomination Status (Yes/No)
                                  </div>
                                }
                              />
                            </Stack>
                          </div> */}

                          <div className={TradingStyles.tcreadmore}>
                            <div
                              className={TradingStyles.tcreadmoreLeft}
                              onClick={() => {
                                setTermsChecked(!termsChecked);
                              }}
                            >
                              <img
                                src={termsChecked ? TickCircle : EmptyCircle}
                              />{" "}
                              I have read and agree to the Terms & Conditions
                            </div>
                            <div
                              className={TradingStyles.tcreadmoreRight}
                              onClick={() => {
                                setExpandTerms(!expandTerms);
                              }}
                            >
                              Read {expandTerms ? "Less" : "More"}{" "}
                              <KeyboardArrowDownIcon
                                style={{
                                  color: "var(--ds-text-primary)",
                                  transform: expandTerms
                                    ? "rotate(-180deg)"
                                    : "",
                                  transition: "all 0.3s ease",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={TradingStyles.buttonStack}>
                          {/* <div className={TradingStyles.tcreadmore}>
                            <div
                              className={TradingStyles.tcreadmoreLeftMobile}
                              onClick={() => {
                                setTermsChecked(!termsChecked);
                              }}
                            >
                              <img
                                src={
                                  termsChecked ? Checkboxdone : Checkboxempty
                                }
                                style={{
                                  marginBottom: "-3px",
                                  marginRight: "-3px",
                                  width: "40px",
                                  height: "40px",
                                }}
                              />{" "}
                              I have read and agree to the Terms & Conditions
                            </div>
                          </div> */}
                          {!showModal && (
                            <div className={TradingStyles.buttonSectionRight}>
                              <Button
                                variant="text"
                                sx={{
                                  color: "var(--ds-text-primary)",
                                  gap: "8px",
                                }}
                                onClick={() => {
                                  navigate("/bank");
                                }}
                                className={TradingStyles.backbutton}
                              >
                                <KeyboardBackspaceIcon /> Back
                              </Button>
                              <LoadingButton
                                id="tradingPreferencesContinueButton"
                                variant="contained"
                                // type="submit"
                                onClick={() => {
                                  handleSubmit();
                                }}
                                className={TradingStyles.approveButton}
                                disabled={
                                  !termsChecked || !nominationInformation
                                }
                              >
                                Continue
                              </LoadingButton>
                            </div>
                          )}
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              ) : (
                <div className={TradingStyles.wrapper}>
                  <BackDrop />
                </div>
              )}

              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={showModal}
                closeAfterTransition
                slotProps={{
                  backdrop: {
                    timeout: 500,
                  },
                }}
              >
                <Fade in={showModal}>
                  <Box className={TradingStyles.boxModalWrapper}>
                    <div className={TradingStyles.riskdisclosuremodalwrapper}>
                      <div className={TradingStyles.riskDisclosuresWrapper}>
                        <div className={TradingStyles.riskdisclosuretopsection}>
                          <div
                            className={TradingStyles.back}
                            onClick={() => {
                              setshowModal(false);
                            }}
                          >
                            <img src={backicon} /> Back
                          </div>
                          <p className={TradingStyles.riskdisclosuresheader}>
                            <div
                              className={TradingStyles.backMobile}
                              onClick={() => {
                                setshowModal(false);
                              }}
                            >
                              <img src={backicon} />
                            </div>{" "}
                            Risk disclosures on derivatives
                          </p>
                        </div>

                        <div
                          className={TradingStyles.riskdisclosurecentersection}
                        >
                          <ul className={TradingStyles.riskdiclosureul}>
                            <li className={TradingStyles.riskdiclosureulli}>
                              9 out of 10 individual traders in equity Futures
                              and Options Segment, incurred net losses.
                            </li>
                            <li className={TradingStyles.riskdiclosureulli}>
                              On an average, loss makers registered net trading
                              loss close to ₹50,000.
                            </li>
                            <li className={TradingStyles.riskdiclosureulli}>
                              Over and above the net trading losses incurred,
                              loss makers expended an additional 28% of net
                              trading losses as transaction costs.
                            </li>
                            <li className={TradingStyles.riskdiclosureulli}>
                              Those making net trading profits, incurred between
                              15% to 50% of such profits as transaction cost.
                            </li>
                          </ul>

                          <p className={TradingStyles.riskdiclosureparadesc}>
                            Source:{" "}
                            <a
                              href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html"
                              target="_blank"
                              className="riskdisclosureatag"
                            >
                              SEBI study{" "}
                            </a>{" "}
                            dated january 25, 2023 on "Analysis of Profit and
                            Loss of Individual Traders dealing in equity Futures
                            and Options (F&O) Segment",wherein Aggregate Level
                            findings are based on annual Profit/Loss invurred by
                            individual traders in equity F&O during FY 2021-22.
                          </p>
                        </div>

                        <div
                          className={TradingStyles.riskdisclosurebuttonsection}
                        >
                          <Button
                            className={TradingStyles.riskdisclosurebutton}
                            variant="contained"
                            sx={{ height: "50px" }}
                            onClick={handleRiskDisclosure}
                          >
                            I understand
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Box>
                </Fade>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
